const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin/manage/groups/categories/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin/manage/groups/categories/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(z.object({
    page: z.number().int().optional(),
    count: z.number().int().optional(),
    search: z.string().optional()
  })),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "All Categories",
      description: "Page title"
    })
  }
});